module.exports = __webpack_public_path__ + "2491ca26ac22702ce04a55ddad3e4180.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/team/Leadership_Curtis_0.jpg
// module id = 390
// module chunks = 0